import React, { useState } from "react";

const EmailActivity = ({ data }) => {
  const email = data && data.new_data;

  if (!email) return null;

  const { subject, html, from_email, from_name } = email;

  return (
    <div className="email-activity">
      <div className="email-row">
        <span className="mlabel">From</span>
        <span className="value">
          {from_name ? `${from_name} <${from_email}>` : from_email || "—"}
        </span>
      </div>
      <div className="email-row">
        <span className="mlabel">Subject</span>
        <span className="value">{subject || "—"}</span>
      </div>



      {html && (
        <div className="email-body">
          <div className="email-body-header">
            <span className="mlabel">Email Content</span>
          </div>
          <div
            className="body-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      )}
    </div>
  );
};

export default EmailActivity;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/activity/EmailActivity.js